import { FC } from "react";
import clsx from "clsx";
import {
  Card,
  CardActionArea,
  CardContent,
  Grid,
  Typography,
} from "@material-ui/core";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import styles from "./service-list.module.scss";
import { ProductListProps } from "./types";

const ServiceList: FC<ProductListProps> = ({
  products,
  onSelectProduct,
  selectedProducts,
}) => {
  return (
    <Grid container>
      {products.map((product) => (
        <Grid item xs={12} key={product.id}>
          <Card
            className={clsx({
              [styles.default]: true,
              [styles.active]:
                selectedProducts.findIndex((prod) => prod.id === product.id) !==
                -1,
            })}
          >
            <CardActionArea
              onClick={() => {
                // just select product (other logic to go to next page)
                onSelectProduct(product);
              }}
            >
              <CardContent
                classes={{
                  root: styles.card_content,
                }}
              >
                {selectedProducts.findIndex(
                  (prod) => prod.id === product.id
                ) !== -1 && (
                  <CheckCircleIcon style={{ float: "right" }} color="primary" />
                )}
                <Typography className={styles.service_name}>
                  {product.name}
                </Typography>
                <Typography className={styles.service_result}></Typography>
                <Typography className={styles.service_description}>
                  {product.description}
                </Typography>
                <Typography className={styles.service_amount}>
                  Precio unitario:{" "}
                  <span className={styles.service_amount_value}>
                    ${product.price}
                  </span>
                </Typography>

                {/* service details */}
                <div
                  style={{
                    marginTop: "40px",
                  }}
                >
                  <Typography className={styles.service_description}>
                    Servicio asociado: {product.serviceName}
                  </Typography>
                  <Typography className={styles.service_amount}>
                    Precio unitario servicio:{" "}
                    <span className={styles.service_amount_value}>
                      ${String(product.servicePrice)}
                    </span>
                  </Typography>
                </div>
              </CardContent>
            </CardActionArea>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

export default ServiceList;
